import { CHATTER_CONSULTATION_REPORT, CHATTER_PROGRAM_CONSULTATION_REPORT, CLASSROOM_PLAN, CONSULTATION_PLAN, DISCHARGE_SCREENING_REPORT, DISCHARGE_SUMMARY_REPORT, INDIVIDUAL_MANAGE_GOALS, INDIVIDUAL_SESSION_REPORT, SCHOOL_ASSESSMENT_REPORT, SCHOOL_CONSULTATION_REPORT, SCHOOL_DISCHARGE_SCREENING_REPORT, SCHOOL_INDIVIDUAL_SESSION_REPORT, TREATMENT_PLAN_REPORT, TREATMENT_SUMMARY_REPORT } from "./paths";

export const API_URL = process.env.REACT_APP_API_BASE_URL;

export const SSO_URL = process.env.REACT_APP_SSO_BASE_URL;

export const CHAT_SERVER_URL = process.env.REACT_APP_CHAT_SERVER_URL;

export const MIME_TYPES = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  webp: "image/webp",
  pdf: "application/pdf",
  video: "video/mp4",
  images: "image/*",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  pptm: "application/vnd.ms-powerpoint.presentation.macroenabled.12"
}

export const PRIMARY_COLOR = "#b46c9f";

export const GENDER_OPTIONS = [
  {
    value: "male",
    label: "Male",
  },
  {
    value: "female",
    label: "Female",
  },
  {
    value: "NA",
    label: "NA",
  },
];

export const SERVICE_STATUS_OPTIONS = [
  {
    value: "NotYetSeen",
    label: "Not Yet Seen",
  },
  {
    value: "Screening",
    label: "Screening",
  },
  {
    value: "Assessment",
    label: "Assessment",
  },
  {
    value: "Individual",
    label: "Individual",
  },
  {
    value: "Classroom",
    label: "Classroom",
  },
  {
    value: "Consultation",
    label: "Consultation",
  },
  {
    value: "Discharge",
    label: "Discharge",
  },
];

export const GRADE_OPTIONS = [
  {
    value: "NA",
    label: "NA",
  },
  {
    value: "PS",
    label: "PS",
  },
  {
    value: "JK",
    label: "JK",
  },
  {
    value: "KG",
    label: "KG",
  },
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
  {
    value: "11",
    label: "11",
  },
  {
    value: "12",
    label: "12",
  },
];

export const CASE_STATUSES = {
  not_seen_yet: "Not Seen Yet"
}

export const GOAL_TRACK_PARAMETERS = {
  "I": "Correct",
  "SC": "Self-correct",
  "P": "Prompt",
  "M": "Model",
  "O": "Incorrect",
};

export const GOAL_TRACK_PARAMETERS_STAFF = {
  "I": "Correct",
  "P": "Prompt",
  "O": "Incorrect",
};

export const GOAL_TRACK_PARAMETERS_COLORS = {
  "I": "#51A5A1",
  "SC": "#D2DA26",
  "P": "#b46c9f",
  "M": "#ffc7ef",
  "O": "#C03017",
};

export const GOAL_TRACK_PARAMETERS_V2 = {
  "O": "Incorrect",
  "M": "Model",
  "P": "Prompt",
  "SC": "Self-correct",
  "I": "Correct",
};

export const GOAL_TRACK_PARAMETERS_COLORS_V2 = {
  "I": "#93288D",
  "SC": "#253D83",
  "P": "#3EA1AA",
  "M": "#D3D926",
  "O": "#D9D9D9",
};

export const REPORTS_V2 = [
  { label: "Discharge Screening Report", value: 9 },
  { label: "Individual Session Report", value: 10 },
  { label: "Consultation Plan Report", value: 11 },
  { label: "Classroom Consultation Plan Report", value: 12 },
  { label: "Assessment Report", value: 13 },
]

export const TASK_PLAN_SESSION_V2 = {
  "O": "Incorrect",
  "P": "Prompt",
  "I": "Correct",
};

export const TASK_PLAN_SESSION_COLOR_V2 = {
  "I": "#93288D",
  "P": "#3EA1AA",
  "O": "#D9D9D9",
};

export const TASK_PLAN_SESSION_CHECKED_COLOR_V2 = {
  "I": "#8F8F8F",
  "P": "#8F8F8F",
  "O": "#D9D9D9",
};

export const REPORT_IDS = {
  TREATMENT_PLAN_REPORT: 1,
  INDIVIDUAL_SESSION_REPORT: 2,
  TREATMENT_SUMMARY_REPORT: 3,
  DISCHARGE_SUMMARY_REPORT: 4,
  CLASSROOM_PLAN: 5,
  CONSULTATION_PLAN: 6,
  DISCHARGE_SCREENING_REPORT: 7,
  CHATTER_PROGRAM_CONSULTATION_REPORT: 8,
  DISCHARGE_SCREENING_REPORT_V2: 9,
  INDIVIDUAL_SESSION_REPORT_V2: 10,
  CONSULATION_REPORT_V2: 11,
  ASSESSMENT_REPORT_V2: 13,
  MULTIDISCIPLINARY: 0,
  CLASSROOM_PLAN_V2: 12,
  CHATTER_CONSULATION_REPORT_V2: 14,
}

export const CLIENT_REPORT_TYPES = {
  [REPORT_IDS.ASSESSMENT_REPORT_V2]: {
    name: "Assessment & Treatment",
    title: "CONFIDENTIAL {DISCIPLINE} ASSESSMENT AND TREATMENT PLAN REPORT",
    path: SCHOOL_ASSESSMENT_REPORT,
    clients: ["school", "home_education", "private"],
    copyType: "assesment_and_treatment",
    sortOrder: 1,
    // disabled: ["home_education"],
  },
  [REPORT_IDS.CONSULATION_REPORT_V2]: {
    name: "Consultation Plan",
    title: "{DISCIPLINE} Consulation Plan",
    path: SCHOOL_CONSULTATION_REPORT,
    // editPath: INDIVIDUAL_SESSION_REPORT,
    clients: ["school", "home_education", "private"],
    copyType: "consultation_plan",
    sortOrder: 2,
    // disabled: ["home_education"],
  },
  [REPORT_IDS.DISCHARGE_SCREENING_REPORT_V2]: {
    name: "Discharge Screening",
    title: "CHATTER PROGRAM CONSULTATION REPORT",
    path: SCHOOL_DISCHARGE_SCREENING_REPORT,
    clients: ["school", "home_education", "private"],
    sortOrder: 3,
    copyType: "discharge_screening",
    disabled: ["home_education", "private"],
  },
  [REPORT_IDS.INDIVIDUAL_SESSION_REPORT_V2]: {
    name: "Individual Session",
    title: "{DISCIPLINE} Session Report",
    path: SCHOOL_INDIVIDUAL_SESSION_REPORT,
    copyType: "individual_session",
    // editPath: INDIVIDUAL_SESSION_REPORT,
    clients: ["school", "home_education", "private"],
    sortOrder: 4,
  },
  [REPORT_IDS.MULTIDISCIPLINARY]: {
    name: "Multidisciplinary",
    title: "Multidisciplinary Report",
    path: TREATMENT_SUMMARY_REPORT,
    clients: ["school", "home_education", "private"],
    sortOrder: 5,
    disabled: true,
  },
  [REPORT_IDS.TREATMENT_SUMMARY_REPORT]: {
    name: "Treatment Summary",
    title: "Confidential {DISCIPLINE} Treatment Summary Report",
    path: TREATMENT_SUMMARY_REPORT,
    clients: ["school", "home_education", "private"],
    sortOrder: 6,
    disabled: true,
  },
  // [REPORT_IDS.INDIVIDUAL_SESSION_REPORT]: {
  //   name: "Individual Session Report",
  //   title: "{DISCIPLINE} Session Report",
  //   path: INDIVIDUAL_MANAGE_GOALS,
  //   editPath: INDIVIDUAL_SESSION_REPORT,
  //   clients: ["home_education", "private"]
  // },
  [REPORT_IDS.TREATMENT_PLAN_REPORT]: {
    name: "Assessment & Treatment Plan",
    title: "CONFIDENTIAL {DISCIPLINE} ASSESSMENT AND TREATMENT PLAN REPORT",
    path: TREATMENT_PLAN_REPORT,
    clients: [],
    disabled: ["private"]
  },
  // [REPORT_IDS.DISCHARGE_SUMMARY_REPORT]: {
  //   name: "Discharge Summary Report",
  //   title: "Confidential {DISCIPLINE} Discharge Summary Report",
  //   path: DISCHARGE_SUMMARY_REPORT,
  //   clients: ["school", "home_education", "private"]
  // },
  [REPORT_IDS.CLASSROOM_PLAN]: {
    name: "Classroom Plan",
    title: "CLASSROOM CONSULTATON PLAN",
    path: CLASSROOM_PLAN,
    clients: []
  },
  [REPORT_IDS.CONSULTATION_PLAN]: {
    name: "Consultation Plan",
    title: "{DISCIPLINE} consultation plan",
    path: CONSULTATION_PLAN,
    clients: [],
    disabled: ["private"]
  },
  // [REPORT_IDS.DISCHARGE_SCREENING_REPORT]: {
  //   name: "Discharge Screening Report",
  //   title: "CONFIDENTIAL SCREENING DISCHARGE REPORT",
  //   path: DISCHARGE_SCREENING_REPORT,
  //   clients: ["school", "home_education", "private"]
  // },
  [REPORT_IDS.DISCHARGE_SCREENING_REPORT]: {
    name: "Discharge Screening Report",
    title: "CONFIDENTIAL SCREENING DISCHARGE REPORT",
    path: DISCHARGE_SCREENING_REPORT,
    clients: [],
    disabled: ["private"]
  },
  // [REPORT_IDS.CHATTER_PROGRAM_CONSULTATION_REPORT]: {
  //   name: "Chatter Program Consultation Report ",
  //   title: "CHATTER PROGRAM CONSULTATION REPORT",
  //   path: CHATTER_PROGRAM_CONSULTATION_REPORT,
  //   clients: ["chatter"]
  // },
  [REPORT_IDS.CHATTER_CONSULATION_REPORT_V2]: {
    name: "Chatter Program Summary Report",
    title: "CHATTER PROGRAM CONSULTATION REPORT",
    path: CHATTER_CONSULTATION_REPORT,
    copyType: "chatter_report",
    clients: ["chatter"]
  },
}

export const REPORT_QUESTIONS = {
  summary: 28,
  recommendation: 29,
  greeting: 30
}

export const INDIVIDUAL_SESSION_REPORT_QUESTIONS = {
  greeting: 86
}

export const TREATMENT_SUMMARY_REPORT_QUESTIONS = {
  notes: 38,
  summary_goals: 39,
  summary_clinical: 40,
  recommendation: 41,
  treatment_summary: 37,
  goal_notes: 38,
  greeting: 77,
}

export const DISCHARGE_SUMMARY_REPORT_QUESTIONS = {
  referral_reason: 42,
  greeting: 47,
  treatment_summary: 48,
  goal_notes: 49,
  recommendation: 74,
}

export const DISCHARGE_SCREENING_REPORT_QUESTIONS = {
  screening_results: 67,
  greeting: 76,
}

export const CONSULTATION_PLANT_REPORT_QUESTIONS = {
  tracker: 64,
  attendance: 89,
}

export const CHATTER_CONSULTATION_PLANT_REPORT_QUESTIONS = {
  tracker: 80,
  program_description: 85,
}

export const CLASSROOM_PLAN_REPORT_QUESTIONS = {
  counter: 60
}

export const INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS = {
  diagnosis: 91,
  session_updates: 92,
  location: 93,
  recommendation: 94,
  customEditor: 97,
  observation: 98,
  multiRecommendation: 99,
}

export const CONSULTATION_REPORT_V2_QUESTIONS = {
  diagnosis: 96,
  customEditor: 97,
  observation: 98,
  multiRecommendation: 99,
}

export const ASSESSMENT_REPORT_V2_QUESTIONS = {
  referral_reason: 105,
  background: 106,
  observation: 107,
  assessment: 108,
  treatment_plan: 109,
  summary: 110,
  clinical_impressions: 111,
  recommendations: 112,
}

export const CLASSROOM_REPORT_V2_QUESTIONS = {
  teacher_concerns: 101,
  classroom_information: 102,
  observation: 103,
  multiRecommendation: 104,
}

export const CHATTER_CONSULTATION_REPORT_V2_QUESTIONS = {
  teacher_concerns: 101,
  classroom_information: 102,
  program_description: 113,
  observation: 115,
  multiRecommendation: 116,
  clinical_summary: 114
}

export const CLIENT_TYPES = [
  {
    label: "Chatter",
    value: "chatter"
  },
  {
    label: "Home Education",
    value: "home_education"
  },
  {
    label: "Private",
    value: "private"
  },
  {
    label: "School",
    value: "school"
  }
]
export const SUPPORT_STAFF_CLIENT_TYPES = [
  {
    label: "Private",
    value: "private"
  },
  {
    label: "School",
    value: "school"
  }
]

export const SUPPORT_STAFF_STATUS_OPTION = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  {
    label: "Archived",
    value: "archived"
  },
]

export const SUPPORT_STAFF_STATUS_EDIT_OPTION = [
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  {
    label: "Archived",
    value: "archived"
  },

]

export const PARENT_CLIENT_TYPES = [
  {
    label: "Chatter",
    value: "chatter"
  },
  {
    label: "Home Education",
    value: "home_education"
  },
  {
    label: "Private",
    value: "private"
  },
]

export const CLIENT_TYPE = {

  school: "School",
  home_education: "Home Education",
  chatter: "Chatter",
  private: "Private"
};

export const CLIENT_NOTE_TYPES = {

  school: "clients-school",
  home_education: "clients-home-education",
  private: "clients-private",
  chatter: "clients-chatter"
}

export const STATUS_OPTIONS = [
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Archived",
    value: "archived"
  }
]

export const GOAL_DESC_WORD_LIMIT = 15;

export const STAFF_DURATION_OPTIONS = [
  {
    value: "no_repeat",
    label: "No Repeat"
  },
  {
    value: "custom",
    label: "Custom"
  }
];

export const STAFF_ENDS_ON_OPTIONS = [
  {
    value: "never",
    label: "Never"
  },
  {
    value: "on_date",
    label: "On Date"
  },
  {
    value: "after",
    label: "After"
  }
];

export const STAFF_ENDS_TRACKER_OPTIONS = [
  {
    value: "frequency",
    label: "Frequency"
  },
  {
    value: "discrete",
    label: "Discrete"
  },
  {
    value: "none",
    label: "None"
  }
];

export const STAFF_TASK_TYPE_OPTIONS = [
  {
    value: "single",
    label: "Individual"
  },
  {
    value: "group",
    label: "Group"
  }
];

export const DAY_OPTIONS = [
  {
    value: "monday",
    label: "Monday",
  },
  {
    value: "tuesday",
    label: "Tuesday",
  },
  {
    value: "wednesday",
    label: "Wednesday",
  },
  {
    value: "thursday",
    label: "Thursday",
  },
  {
    value: "friday",
    label: "Friday",
  },
  {
    value: "saturday",
    label: "Saturday",
  },
  {
    value: "sunday",
    label: "Sunday",
  }
];

export const APPOINTMENT_STATUS_OPTIONS = [
  {
    label: "Accepted",
    value: "accepted",
  },
  {
    label: "Rejected",
    value: "rejected"
  },
  {
    label: "Canceled",
    value: "canceled"
  },
  {
    label: "Completed",
    value: "completed"
  },
  {
    label: "Pending",
    value: "pending"
  },
  {
    label: "Confirmed",
    value: "confirmed"
  }
]

export const PAYMENT_STATUS_OPTIONS = [
  {
    label: "Pending",
    value: "pending"
  },
  {
    label: "Success",
    value: "success"
  },
  {
    label: "Failed",
    value: "failed"
  },
  {
    label: "Refund",
    value: "refund"
  }
]

export const APPOINTMENT_TYPE_OPTIONS = [
  {
    label: "Free",
    value: "free"
  },
  {
    label: "Paid",
    value: "paid"
  }
]

export const APPOINTMENT_LOCATION_OPTIONS = [
  {
    label: "In Person",
    value: "in_person"
  },
  {
    label: "By Phone",
    value: "by_phone"
  },
  {
    label: "Zoom Video Call",
    value: "video_zoom"
  }
]

export const CLIENT_TYPE_KEYS = Object.fromEntries(Object.keys(CLIENT_TYPE).map(key => [key, key]));

export const DISCIPLINE_REPORT_NAME_MAPPING = {
  7: "Speech Language Pathology",
  8: "Learning",
  9: "Behavior",
  10: "Occupational Therapy",
  11: "Physical Therapy",
}

export const SPECIALIZATION_OPTIONS = {
  "psychologist": "Psychologist",
  "pediatrician": "Pediatrician",
}

export const CHATTER_LOCATION_TYPE_OPTIONS = [
  {
    label: "School",
    value: "school"
  },
  {
    label: "Community",
    value: "community"
  }
]

export const RTK_CACHE_EXPIRATION = 60 * 10; // in seconds


export const ATTENDANCE_QUESTION_IDS = [CONSULTATION_PLANT_REPORT_QUESTIONS?.attendance];

export const TIMEZONE_OPTIONS = [
  { label: "MST", value: "MST" },
  { label: "CST", value: "CST" },
  { label: "EST", value: "EST" },
]

export const TASK_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Submitted", value: "submitted" },
  { label: "Completed", value: "completed" },
  { label: "In-process", value: "in-process" },
]
export const TASK_STATUS_OPTIONS_V2 = [
  { label: "All", value: "" },
  { label: "Pending", value: "pending" },
  { label: "In Progress", value: "in_progress" },
  { label: "Completed", value: "completed" },
] 

export const CHATTER_MEMEBER_TYPES = [
  { label: "Chatter Client", value: "chatter" },
  { label: "Chatter Peer", value: "peer" },
]

export const NO_HISTORY_FOUND = 'No History Found'

export const dobFormat = "MMM DD, YYYY";

export const reportDateFormat = "MMM DD, YYYY";

export const MAX_REPORT_ASSESSMENTS = 4;

export const extractUploadFileName = (file) => {
  if (!file) {
    return
  }
  return file.split('/').pop().split('?')[0]
}

export const DEFAULT_ASSESSMENT_TEMPLATE = {
  title: "Informal Assessment",
  description: "<p>An <strong>informal assessment</strong> was completed in the areas described below using observations and non standardized measures.</p>"
}

export const STRATEGY_OPTIONS = [
  { label: "Choose from My Library", value: "oldStrategy" },
  { label: "Create New Strategy", value: "new" },
]

export const AUTOSAVE_TOAST_OPTIONS = {
  pending: 'Autosaving...',
  success: 'All changes saved',
  error: 'Failed to save changes',
  position: 'top-center',
  autoClose: 1000, // hide after 1 second
  hideProgressBar: true,
  className: 'small-toast',
}

export const classroomReportStatusOptions = [
  { label: "In-progress", value: "in-progress" },
  { label: "Copied", value: "copied" },
  { label: "Published", value: "complete" },
]

export const CLIENT_STATUS_OPTION = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  // {
  //   label: "Archived",
  //   value: "archived"
  // },
  {
    label: "Discharged",
    value: "discharged"
  }
]

export const CHATTER_STATUS_OPTION = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  // {
  //   label: "Archived",
  //   value: "archived"
  // },
  {
    label: "Discharged",
    value: "discharged"
  }
]
export const ATTENDANCE_OPTIONS = [
  { label: "Present", value: "present" },
  { label: "Absent", value: "absent" },
]

export const DOCUMENT_TYPE_OPTIONS = [
  { label: "Consent", value: "consent" },
  { label: "Document", value: "document" },
  { label: "Report", value: "report" },
]

export const REPORTS_FILTER_OPTIONS = [
  {
    label: "Copied",
    value: "copied"
  },
  {
    label: "Published",
    value: "complete"
  },
  {
    label: "In Progress",
    value: "processing"
  },
]

export const DOCUMENTS_FILTER_OPTIONS = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Document",
    value: "document"
  },
  {
    label: "Report",
    value: "report"
  },
  {
    label: "Consent",
    value: "consent"
  },
]

export const TASK_PLAN_MOOD_OPTIONS_V2 = {
  ENGAGEMENT: {
    title: "Engagement",
    options: {
      DIFFICULT_TO_ENGAGE: "Difficult to engage",
      ENGAGED_WITH_PROMPTING: "Engaged with prompting",
      EASILY_ENGAGED: "Easily engaged",
    },
  },
  ATTENTION: {
    title: "Attention",
    options: {
      NEEDED_FREQ_REDIRECTION: "Needed freq. redirection",
      MILDLY_DISTRACTED: "Mildly distracted",
      SUSTAINED: "Sustained",
    },
  },
};